import { runInInjectionContext, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
type StepOptions = Shepherd.Step.StepOptions;
import { commonConfig, waitForElement } from './utils';

export function getFavoritesTourMobileSteps(injector: Injector): StepOptions[] {
  return runInInjectionContext(injector, () => {
    const router = inject(Router);

    return [
      {
        id: 'Favorites-step-mobile-01',
        title: 'Manage your Favorites',
        text: 'Click here to access and manage your favorites.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#NotificationsMobileStep1',
          on: 'bottom-end' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/favorites']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Favorites-step-mobile-02',
        title: 'Your Saved Publications',
        text: 'This dashboard provides a comprehensive view of all your saved publications, allowing for efficient navigation between your bookmarked content.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#FavoritessStep2',
          on: 'top' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#FavoritessStep2').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Favorites-step-mobile-03',
        title: 'Toggle Favourites',
        text: 'Add a publication to your favourites by clicking this button. To remove it, simply click the same button again.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#headline-odd-0 #teaser-0 .Add',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Finish',
            action() {
              this.complete();
              router.navigate(['/site/help']);
            }
          }
        ],
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            if (router.url !== '/site') {
              router.navigate(['/site']).then(() => {
                waitForElement('#headline-odd-0 #teaser-0 .Add').then(() => {
                  resolve();
                });
              });
            } else {
              waitForElement('#headline-odd-0 #teaser-0 .Add').then(() => {
                resolve();
              });
            }
          });
        }
      }
    ];
  });
}